import { useHttp } from '@/api'
import { httpApi } from '@/api/api'

/**
 * 担当者別の年間売上実績の検索
 */
export function SearchAnnualSalesByUserData(data) {
  return new Promise((resolve, reject) => {
    useHttp()
      .request(httpApi.SearchAnnualSalesByUserData,data)
      .then(res => {
        resolve(res)
      })
      .catch(err => {
        reject(err)
      })
  })
}

/**
 * 担当者別の年間売上実績の出力
 */
export function OutputAnnualSalesByUserData(data) {
  return new Promise((resolve, reject) => {
    useHttp()
      .request(httpApi.SearchAnnualSalesByUserData, data)
      .then(res => {
        resolve(res)
      })
      .catch(err => {
        reject(err)
      })
  })
}

/**
 * 個人売上詳細の検索
 */
export function SearchAnnualSalesDetailByUserData(data) {
  return new Promise((resolve, reject) => {
    useHttp()
      .request(httpApi.SearchAnnualSalesDetailByUserData,data)
      .then(res => {
        resolve(res)
      })
      .catch(err => {
        reject(err)
      })
  })
}

/**
 * 個人売上詳細の更新
 */
export function UpdateAnnualSalesDetailByUserData(data) {
  return new Promise((resolve, reject) => {
    useHttp()
      .request(httpApi.UpdateAnnualSalesDetailByUserData,data)
      .then(res => {
        resolve(res)
      })
      .catch(err => {
        reject(err)
      })
  })
}
